module.exports = __webpack_public_path__ + "static/media/cars.868fcf18.svg";